import { Card, Stack } from "react-bootstrap";

import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import annotationPlugin from "chartjs-plugin-annotation";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { useMemo } from "react";
import { Doughnut } from "react-chartjs-2";
import LoadingIndicator from "../LoadingIndicator";
import ErrorResponse from "../ErrorResponse";
import RATooltip from "../RATooltip";
import { doughnutOptions, htmlLegendPlugin } from "../chartOptions";

ChartJS.register(ArcElement, Tooltip, Legend, annotationPlugin, ChartDataLabels);

export default function DevicesCard({ data, loading, error, isFullDaypart = true }) {
    const chartData = useMemo(() => {
        if (data) {
            const hasApp = data.own_app.time_frame > 1 || data.own_app.average > 1;
            const labels = ["PC", "Smart Speaker", hasApp ? "Mobile (No App)" : "Mobile"];
            if (hasApp) {
                labels.push("Mobile (App)");
            }
            return {
                labels: labels,
                datasets: [
                    {
                        label: "Time Frame",
                        type: "doughnut",
                        backgroundColor: ["#40775A", "#A3CCB6", "#519872", "#67CB88"],
                        data: [
                            data?.pc.time_frame,
                            data?.smart_speaker.time_frame,
                            data?.mobile.time_frame,
                            hasApp ? data?.own_app.time_frame : "N/A",
                        ],
                        datalabels: {
                            anchor: "end",
                        },
                    },
                    {
                        label: "Average",
                        type: "doughnut",
                        backgroundColor: ["#40775A", "#A3CCB6", "#519872", "#67CB88"],
                        data: [
                            data?.pc.average,
                            data?.smart_speaker.average,
                            data?.mobile.average,
                            hasApp ? data?.own_app.average : "N/A",
                        ],
                        datalabels: {
                            anchor: "start",
                        },
                    },
                ],
            };
        }
    }, [data]);

    return (
        <Card>
            <Card.Header className={`d-flex align-items-center px-2 ${isFullDaypart ? "" : "health-daypart-header"}`}>
                <span className={`offset-1 flex-grow-1`}>Devices</span>
                <div className="col-1 d-flex justify-content-end">
                    <RATooltip size={20}>
                        <Stack gap={2}>
                            <span>Percentage of sessions by device type.</span>
                        </Stack>
                    </RATooltip>
                </div>
            </Card.Header>
            <Card.Body className="py-0 card-health-chart d-flex">
                {loading ? (
                    <LoadingIndicator width={85} />
                ) : error ? (
                    <ErrorResponse errorCode={error} />
                ) : (
                    <>
                        <Stack id="legend-container-devices" className="py-3"></Stack>
                        <Doughnut data={chartData} options={doughnutOptions("legend-container-devices")} plugins={[htmlLegendPlugin]} />
                    </>
                )}
            </Card.Body>
        </Card>
    );
}
